const routes = [
  {
    index: true,
    label: 'Ian Randman',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Rides',
    path: '/rides',
  },
  // {
  //   label: 'Route Map',
  //   path: '/route-map',
  // },
  // {
  //   label: 'Blog',
  //   path: '/blog',
  // },
  // {
  //   label: 'Instagram',
  //   path: '/instagram',
  // },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Press',
    path: '/press',
  },
  // {
  //   label: 'Projects',
  //   path: '/projects',
  // },
  // {
  //   label: 'Stats',
  //   path: '/stats',
  // },
  {
    label: 'Contact',
    path: '/contact',
  },
  {
    label: 'Fundraiser',
    path: '/fundraiser',
  },
];

export default routes;
